import React from "react";
import { Lotus, Mandala } from "@/components/decor/Motifs";

const items = [
    {
        time: "10:00 AM",
        title: "Pushpodan & Kirtan Mela",
        body: "The day awakens with flower offerings and a rolling kirtan — voices, mridangas and karatalas rise together in praise.",
        tag: "Opening Ritual",
    },
    {
        time: "12:00 PM",
        title: "Peralal Priorities — Keynote",
        body: "Dr. Jitendra Nath Adhikary unfolds the priorities of a life truly lived — a talk crafted for the modern student soul.",
        tag: "Keynote Discourse",
        speaker: "Dr. Jitendra Nath Adhikary",
        speakerRole: "Professor",
        speakerDept: "Department of Anatomy and Histology",
        speakerInst: "Sylhet Agricultural University, Bangladesh",
    },
    {
        time: "1:00 PM",
        title: "Q&A Session",
        body: "Bring your honest questions. Doubts, dilemmas, tender wonderings — all welcome under the flute-tree of dialogue.",
        tag: "Interactive",
    },
    {
        time: "2:00 PM",
        title: "Audience Forum & Winner Prize Distribution",
        body: "A community forum followed by celebrations for our winners — cheers, applause and a shower of blessings.",
        tag: "Celebration",
    },
    {
        time: "2:30 PM",
        title: "Spiritual Theme Dance & Short Drama",
        body: "Costumes, choreography and story-craft — pastimes of the Lord retold by youth for youth.",
        tag: "Performance",
    },
    {
        time: "3:30 PM",
        title: "Gifts Distribution",
        body: "Every registered soul walks away with a token of remembrance — books, tees, and heart-shaped surprises.",
        tag: "Gifts",
    },
    {
        time: "4:00 PM",
        title: "Prasad Distribution",
        body: "The day closes with sanctified food — cooked with prayer, offered with love, shared as one family.",
        tag: "Prasad",
    },
];

export default function Schedule() {
    return (
        <section
            id="schedule"
            className="relative px-6 md:px-12 lg:px-24 py-20 md:py-28 bg-gradient-to-b from-cream-50 via-cream-100 to-cream-50 overflow-hidden"
            data-testid="schedule-section"
        >
            <Mandala className="absolute -top-40 -right-40 w-[520px] h-[520px] opacity-[0.08] animate-spin-slow" />
            <Mandala className="absolute -bottom-40 -left-40 w-[480px] h-[480px] opacity-[0.08] animate-spin-slower" />

            <div className="relative mx-auto max-w-5xl">
                <div className="text-center max-w-2xl mx-auto mb-16">
                    <p className="font-body text-xs uppercase tracking-[0.35em] text-maroon-600">
                        Programme of the Day · 17 July 2026
                    </p>
                    <h2 className="mt-3 font-heading text-4xl md:text-5xl font-semibold text-inkbrown-900">
                        Six hours of song, wisdom &amp; sweetness
                    </h2>
                </div>

                <ol className="relative border-l-2 border-dashed border-vgold-400/50 pl-6 md:pl-10 space-y-10">
                    {items.map((it, idx) => (
                        <li
                            key={it.time}
                            className="relative"
                            data-testid={`schedule-item-${idx}`}
                        >
                            <span className="absolute -left-[42px] md:-left-[54px] top-1 flex items-center justify-center">
                                <span className="absolute w-10 h-10 rounded-full bg-saffron-500/25 animate-pulse" />
                                <span className="relative w-6 h-6 rounded-full bg-saffron-500 border-4 border-cream-50 shadow-divine" />
                            </span>
                            <div className="glass-gold rounded-2xl p-6 md:p-8 hover:shadow-glow transition-all">
                                <div className="flex flex-wrap items-baseline justify-between gap-3">
                                    <span className="font-title text-2xl md:text-3xl text-maroon-600 font-bold tracking-wide">
                                        {it.time}
                                    </span>
                                    <span className="inline-block rounded-full bg-vgold-400/15 border border-vgold-400/40 text-vgold-700 font-body text-[10px] uppercase tracking-[0.25em] px-3 py-1">
                                        {it.tag}
                                    </span>
                                </div>
                                <h3 className="mt-3 font-heading text-2xl md:text-3xl text-inkbrown-900">
                                    {it.title}
                                </h3>
                                {it.speaker && (
                                    <div className="mt-4 flex items-center gap-3 rounded-2xl bg-gradient-to-r from-saffron-50 to-vgold-50 border border-vgold-200 px-4 py-3">
                                        <span className="grid place-items-center w-10 h-10 rounded-full bg-saffron-500 text-white font-title text-sm shrink-0">
                                            Dr
                                        </span>
                                        <div className="leading-tight min-w-0">
                                            <p className="font-body text-[10px] uppercase tracking-[0.3em] text-maroon-600">
                                                Keynote Speaker
                                            </p>
                                            <p className="mt-0.5 font-heading text-xl md:text-2xl text-inkbrown-900 font-semibold">
                                                {it.speaker}
                                            </p>
                                            {it.speakerRole && (
                                                <p className="font-body text-sm text-inkbrown-700">
                                                    {it.speakerRole}
                                                    {it.speakerDept ? ` · ${it.speakerDept}` : ""}
                                                </p>
                                            )}
                                            {it.speakerInst && (
                                                <p className="font-body text-sm text-inkbrown-500 italic">
                                                    {it.speakerInst}
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                )}
                                <p className="mt-3 font-body text-base text-inkbrown-500 leading-relaxed">
                                    {it.body}
                                </p>
                            </div>
                        </li>
                    ))}
                </ol>

                <div className="mt-16 flex items-center justify-center">
                    <Lotus className="w-10 h-10" />
                </div>
            </div>
        </section>
    );
}
